// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2vCb1","dragIcon":"SortableItem_dragIcon__2zp2J","disabled":"SortableItem_disabled__2kyr1"};